import { React, useEffect, useState, useRef, createRef } from 'react';
import { useSnackbar } from 'notistack';
import AlertDialog from '../Modals/AlertDialog'
import Badge from '@mui/material/Badge';
import { Link } from 'react-router-dom';
import {
    Fab,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button
}
    from '@mui/material/'


import TouchRipple from '@mui/material/ButtonBase/TouchRipple';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

export default function TrainingItemsIndicator(props) {

    const [showRemainingItemsDialog, setShowRemainingItemsDialog] = useState(props.ShowDialog !== undefined ? props.ShowDialog : false);
    const rippleButton = useRef(null);
    const rippleTimeout = useRef();
    

    useEffect(() => {
        if (props != undefined) {
            rippleTimeout.current = window.setTimeout(ripple, 500);
        }
    }, []);

    function ripple() {
        if (!showRemainingItemsDialog) {
           // console.log('ripple: showRemainingItemsDialog is false');
            if (rippleTimeout.current != null) {
                window.clearTimeout(rippleTimeout.current);
            }
            window.setTimeout(function () {
                if (rippleButton.current !== null) {
                    rippleButton.current.start();
                    window.setTimeout(function () {
                        if (rippleButton != undefined && rippleButton != null) {
                            rippleButton.current.stop();
                        }
                        
                    }, 500);
                }
                rippleTimeout.current = window.setTimeout(ripple, 1000);
            }, 200);

        }
        else {
          //  console.log('ripple: showRemainingItemsDialog is false');
            rippleTimeout.current = window.setTimeout(ripple, 1000);
        }
    }


    function showRemainingItems() {
        return (<Dialog
            open={true}
            onClose={() => setShowRemainingItemsDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Account Setup Checklist
            </DialogTitle>
            <DialogContent>
                <div>
                    <div style={{marginBottom:'10px', paddingBottom:'10px', borderBottom:'1px solid #efefef'} }>
                        Before you get started, you have <span style={{ color: 'var(--sipzee-red)' }}>{props.TrainingChecklist.RemainingItemCount} </span>
                        item{props.TrainingChecklist.RemainingItemCount > 1 ? 's' : '' } in your Account Setup Checklist that you must complete
                    </div>
                    
                    {!props.TrainingChecklist.NeedsParentGuardianConsent ? null :
                        <div>
                            <div style={{ display: 'flex' }}>
                                {props.TrainingChecklist.HasParentGuardianConsent ?
                                    <AssignmentTurnedInIcon sx={{ color: 'var(--sipzee-green)', fontSize: 40 }} />
                                    :
                                    <AssignmentIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                                }
                                <div style={{ alignSelf: 'center', fontWeight: 'bold', marginLeft: '20px' }}>Parental Consent Form</div>
                            </div>
                            {props.TrainingChecklist.HasParentGuardianConsent ? null :
                                <div>
                                    Please download the <a target='_blank' href='https://sipzee.com/content/terms_and_policy/Parent%20Guardian%20Consent%20Form%2010-21-2020.pdf'>Parental Consent</a> form and email to info@sipzee.com
                                </div>

                            } 
                        </div>
                    }
                    
                        <div>
                            <div style={{ display: 'flex' }}>
                            {props.TrainingChecklist.IsTrainingCompleted ?
                                    <AssignmentTurnedInIcon sx={{ color: 'var(--sipzee-green)', fontSize: 40 }} />
                                    :
                                    <AssignmentIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                                }
                            <div style={{ alignSelf: 'center', fontWeight: 'bold', marginLeft: '20px' }}>Complete the <Link to='/Training'>Training Module</Link></div>
                           
                        </div>
                        {props.TrainingChecklist.IsTrainingCompleted ? null :
                            <div style={{ fontStyle: 'italic', marginLeft: '60px' }}>in Training</div>
                        }
                        </div>
                    
                    <div>
                        <div style={{ display: 'flex' }}>
                            {props.TrainingChecklist.HasPhoto ?
                                <AssignmentTurnedInIcon sx={{ color: 'var(--sipzee-green)', fontSize: 40 }} />
                                :
                                <AssignmentIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                            }
                            <div style={{ alignSelf: 'center', fontWeight: 'bold', marginLeft: '20px' }}>Add a Profile Photo</div>
                            
                        </div>
                        {props.TrainingChecklist.HasPhoto ? null :
                            <div style={{ fontStyle: 'italic', marginLeft: '60px' }}>in <Link to='/MyAccount'>My Account</Link></div>
                        }
                    </div>

                    <div>
                        <div style={{ display: 'flex' }}>
                            {props.TrainingChecklist.IsPhoneNumberVerified ?
                                <AssignmentTurnedInIcon sx={{ color: 'var(--sipzee-green)', fontSize: 40 }} />
                                :
                                <AssignmentIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                            }
                            <div style={{ alignSelf: 'center', fontWeight: 'bold', marginLeft: '20px' }}>Verify your Phone Number</div>
                           
                        </div>
                        {props.TrainingChecklist.IsPhoneNumberVerified ? null :
                            <div style={{ fontStyle: 'italic', marginLeft: '60px' }}>in <Link to='/MyAccount'>My Account</Link></div>
                        }
                    </div>

                    <div>
                        <div style={{ display: 'flex' }}>
                            {props.TrainingChecklist.HasServiceAreas ?
                                <AssignmentTurnedInIcon sx={{ color: 'var(--sipzee-green)', fontSize: 40 }} />
                                :
                                <AssignmentIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                            }
                            <div style={{ alignSelf: 'center', fontWeight: 'bold', marginLeft: '20px' }}>Add your Service Area</div>
                           
                        </div>
                        {props.TrainingChecklist.HasServiceAreas ? null :
                            <div style={{ fontStyle: 'italic', marginLeft: '60px' }}>in <Link to='/MyAccount'>My Account</Link></div>
                        }
                    </div>
                   
                    <div>
                        {props.TrainingChecklist.HasPhotoId ? 
                            <div style={{ display: 'flex' }}>
                                <AssignmentTurnedInIcon sx={{ color: 'var(--sipzee-green)', fontSize: 40 }} />
                                <div style={{ alignSelf: 'center', fontWeight: 'bold', marginLeft: '20px' }}>Add a Govt Issued Photo Id</div>
                            </div>
                            :
                            <div style={{ display: 'flex' }}>
                                <AssignmentIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                                <div style={{ alignSelf: 'center', fontWeight: 'bold', marginLeft: '20px' }}>Add a Govt Issued Photo Id</div>
                            </div>
                        }
                       
                        {props.TrainingChecklist.HasServiceAreas ? null :
                            <div style={{ fontStyle: 'italic', marginLeft: '60px' }}>in <Link to='/MyAccount'>My Account</Link></div>
                        }
                    </div>
                    <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={() => setShowRemainingItemsDialog(false)}>Close</Button>
                    </div>
                </div>
            </DialogContent>
            
        </Dialog>)
    }

    return (
        <>
            {props == undefined ? null :
                (props.ShowIndicator == false || props.TrainingChecklist.RemainingItemCount === 0) ? null :
                    <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'flex-end' }}>
                        <div>
                            <Badge badgeContent={props.TrainingChecklist.RemainingItemCount}
                                color="sipzeeRed"
                                overlap="circular"
                                sx={{ zIndex: 1051 }}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                            >

                                <Fab sx={{ backgroundColor: 'var(--sipzee-yellow)' }} onClick={() => { setShowRemainingItemsDialog(true); window.clearTimeout(rippleTimeout.current); }}>
                                    <>
                                        <TouchRipple ref={rippleButton} center={true} />
                                        <ManageAccountsIcon />
                                    </>
                                </Fab>


                            </Badge>
                            <div style={{ fontSize: '8pt' }}>Account Setup</div>
                        </div>
                    </div>
            }
            {showRemainingItemsDialog || props.ShowDialog ? 
                showRemainingItems()
                :
                null
             }
            </>
        )
}